export default {"src":"/_next/static/media/Prostate-Cancer.4be480b0.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};